import { DownloadOrdersButton } from 'App/Components/DownloadOrdersButton/DownloadOrdersButton';
import { renderDate } from 'utils';
import { Certified } from './components/Certified/Certified';
import { ExamsResult } from './components/ExamsResult/ExamsResult';
import { LabelLink } from './components/LabelLink/LabelLink';
import { Status } from './components/Status/Status';

type StatusProps =
	| 'finished'
	| 'partial'
	| 'pendent'
	| 'canceled'
	| 'deprecated'
	| 'expired'
	| 'pendingResult'
	| 'queued';

export const formattedRows = (
	data: any,
	handleOpenCandidate: (id: string) => void,
	handleShowResults: (candidate: any) => void,
) => {
	return (
		data?.candidates?.map((candidate: any) => {
			const examsResult: { status: StatusProps }[] =
				candidate?.exams?.map((exam: any) => ({
					status: exam.orderStatus,
				})) || [];

			const orders =
				candidate?.exams?.map((exam: any) => ({
					orderId: exam.externalOrderId,
					appointmentId: exam.appointmentId,
					healthCenterName: exam.healthCenterName,
					orderStatus: exam.orderStatus,
					name: exam.name,
				})) || [];

			return {
				id: candidate.id,
				employeeId: candidate.employeeId,
				createdBy: candidate.createdBy || '-',
				customBusinessName: candidate.customBusinessName || '-',
				name: (
					<LabelLink
						key={candidate.name}
						active={candidate?.hrApprovalStatus === 'pendent'}
						onClick={() => handleOpenCandidate(candidate.id)}
						title={candidate.name}
					/>
				),
				puesto: candidate.position,
				statusDoctor: (
					<Status
						key={candidate.doctorApprovalStatus}
						nameDoctor={candidate.doctorApprovalStatus}
					/>
				),
				results: (
					<ExamsResult
						exams={examsResult}
						preventTooltip={true}
						onClick={() => handleShowResults(candidate)}
						key={candidate.name}
					/>
				),
				serviceRequest: (
					<DownloadOrdersButton
						exams={orders}
						key={candidate.name}
						id={candidate.id}
						appointmentId={candidate.appointmentId}
						name={candidate.name}
					/>
				),
				certifiedFile: (
					<Certified
						key={candidate?.certificateFile?.path}
						path={candidate?.certificateFile?.path}
					/>
				),
				statusRH: (
					<Status
						key={candidate.hrApprovalStatus}
						nameRh={candidate.hrApprovalStatus}
					/>
				),
				doctorApprover: candidate.doctorApprovalByUser?.name,
				hrApprover: candidate.hrApprovalByUser?.name,
				destinationBranchOffice: candidate.destinationBranchOffice?.name,
				phone: candidate.phone,
				email: candidate.email,
				createdAt: renderDate(candidate.createdAt),
				labRequestedAt: renderDate(candidate.labRequestedAt),
				externalOrderCreatedAt: renderDate(candidate.externalOrderCreatedAt),
				resultReceivedAt: renderDate(candidate.resultReceivedAt),
				doctorApprovalAt: renderDate(candidate.doctorApprovalAt),
			};
		}) ?? []
	);
};
